type ItemWithAdminName = {
  adminName?: string | null;
  title?: string;
  subject?: string;
};

const normalize = (val?: string | null): string | null =>
  val && val.trim() ? val : null;

export const resolveExpTitle = (name: string, expTitle: string): string =>
  name.replace(/\{\{\s*experience\.title\s*\}\}/g, expTitle);

export const getItemDisplayName = (item: ItemWithAdminName): string =>
  normalize(item.adminName) ?? normalize(item.title) ?? normalize(item.subject) ?? '';

export const getItemDisplayPair = (
  item: ItemWithAdminName
): { primary: string; secondary?: string } => {
  const adminName = normalize(item.adminName);
  const titleOrSubject = normalize(item.title) ?? normalize(item.subject) ?? '';
  if (adminName) {
    return { primary: adminName, secondary: titleOrSubject };
  }
  return { primary: titleOrSubject };
};

export const getItemReferenceName = (item: ItemWithAdminName): string => {
  const adminName = normalize(item.adminName);
  const titleOrSubject = normalize(item.title) ?? normalize(item.subject) ?? '';
  if (adminName) {
    return `${adminName} (${titleOrSubject})`;
  }
  return titleOrSubject;
};
